import { render, staticRenderFns } from "./OrganizationChallenges.vue?vue&type=template&id=e982b9c4&scoped=true&lang=pug&"
import script from "./OrganizationChallenges.vue?vue&type=script&lang=js&"
export * from "./OrganizationChallenges.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationChallenges.vue?vue&type=style&index=0&id=e982b9c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e982b9c4",
  null
  
)

export default component.exports